(() => {
  const SELECTOR = '[data-vorix-ai-discovery]';

  function normalize(value) {
    return value.toLocaleLowerCase().normalize('NFKC');
  }

  function groupFor(value) {
    const input = normalize(value);
    if (['fenster', 'ablak', 'window'].some((word) => input.includes(word))) return 'window';
    if (['motor', 'klopf', 'klopfen', 'geräusch', 'geraesch', 'kopog', 'zaj'].some((word) => input.includes(word))) return 'engine';
    if (['polter', 'fahrwerk', 'futómű'].some((word) => input.includes(word))) return 'suspension';
    return 'default';
  }

  function textElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    element.textContent = text;
    return element;
  }

  function render(section, config) {
    const input = section.querySelector('.vorix-ai-input');
    const result = section.querySelector('.vorix-ai-result');
    const data = config.groups[groupFor(input?.value || '')] || config.groups.default;
    if (!result || !data) return;

    const card = document.createElement('div');
    card.className = 'vorix-ai-card';
    card.append(textElement('div', 'vorix-ai-confidence', data.confidence));
    card.append(textElement('h3', '', `${config.systemLabel} ${data.cluster}`));
    card.append(textElement('div', 'vorix-ai-section-label', config.relatedLabel));

    data.links.forEach(([label, href]) => {
      const link = textElement('a', 'vorix-ai-chip', label);
      link.href = href;
      card.append(link);
    });

    card.append(textElement('div', 'vorix-ai-section-label vorix-ai-section-label--spaced', config.moreLabel));
    data.related.forEach((label) => card.append(textElement('span', 'vorix-ai-chip', label)));
    result.replaceChildren(card);
  }

  function init(section) {
    if (section.dataset.vorixAiReady === 'true') return;
    const configNode = section.querySelector('[data-vorix-ai-config]');
    const button = section.querySelector('[data-vorix-ai-resolve]');
    const input = section.querySelector('.vorix-ai-input');
    if (!configNode || !button || !input) return;

    let config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      console.error('VORIX AI Discovery configuration is invalid.', error);
      return;
    }

    button.addEventListener('click', () => render(section, config));
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        render(section, config);
      }
    });
    section.dataset.vorixAiReady = 'true';
  }

  function initAll(root = document) {
    if (root.matches?.(SELECTOR)) init(root);
    root.querySelectorAll?.(SELECTOR).forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
